<fieldset [formGroup]="form">
  <div class="pb-1">
    <app-checkbox
      class="fs-sm"
      [testId]="[testId, 'permanent_substitution'].join('_')"
      label="{{ 'module.substitute.add-form.permanent-substitute' | translate }}"
      formControlName="is_permanent"
    ></app-checkbox>
  </div>

  <div class="pb-1q">
    <app-input-search-dropdown
      [formControl]="form.get('user')"
      [itemsList]="userSearch"
      (onSearch)="getUsers($event)"
      [isRequired]="true"
      [itemLabelFn]="getUserLabel.bind(this)"
      [testId]="[testId, 'user'].join('_')"
      [isLoading]="isUserLoading.asObservable()"
      inputLabel="{{ 'module.substitute.add-form.affected-user' | translate }}">
    </app-input-search-dropdown>
  </div>

  <div class="pb-1q" style="position: relative;">
    <app-input-search-dropdown
      *ngIf="!multipleDelegates"
      [formControl]="form.get('substituteUser')"
      [itemsList]="userSearch"
      (onSearch)="getUsers($event)"
      [isRequired]="true"
      [itemLabelFn]="getUserLabel.bind(this)"
      [testId]="[testId, 'user'].join('_')"
      [isLoading]="isUserLoading.asObservable()"
      inputLabel="{{ (multipleDelegates ? 'module.substitute.add-form.delegate-s' : 'module.substitute.add-form.delegate') | translate }}">
    </app-input-search-dropdown>
    <app-multiselect-search-dropdown
        *ngIf="multipleDelegates"
        label="{{ (multipleDelegates ? 'module.substitute.add-form.delegate-s' : 'module.substitute.add-form.delegate') | translate }}"
        [formControl]="form.get('substituteUser')"
        [useCustomToggler]="false"
        [isRequired]="true"
        [disableOptionCentering]="true"
        [itemListProvider]="userListProvider">
    </app-multiselect-search-dropdown>
  </div>


  <div class="pb-1">
    <legend class="hidden">Start date</legend>
    <app-date-picker
      formControlName="startDate"
      rangeClass="w-100"
      [shouldShowLabel]="true"
      [inputLabel]="'module.substitute.add-form.start-date' | translate"
      [testId]="[testId, 'start_date'].join('_')"
      [minDate]="today"
      [maxDate]="form.get('endDate')?.value"
    ></app-date-picker>
  </div>

  <div class="pb-1">
    <legend class="hidden">End Date</legend>

    <app-date-picker
      formControlName="endDate"
      [isRequired]="!form.get('is_permanent').value"
      [minDate]="form.get('startDate')?.value"
      rangeClass="w-100"
      [shouldShowLabel]="true"
      [inputLabel]="'module.substitute.add-form.end-date' | translate"
      [testId]="[testId, 'end_date'].join('_')"
    ></app-date-picker>

  </div>

</fieldset>
